import React from "react";
import styled from "styled-components";
import { InfoIcon } from "Shared/Icons";
import { darken } from "@material-ui/core/styles/colorManipulator";
import { useTranslation } from "react-i18next";
import { MessageBubble, MessageWrapper } from "src/components/Messaging/Messages/Message";

interface Props {
    message: string;
    retry: () => void;
}

const ErrorWrapper = styled("div")`
    flex-direction: row;
    display: flex;
    align-items: flex-end;
`;

const RetryIcon = styled(InfoIcon)`
    color: white;
    background-color: #f00;
    border-radius: 100%;
    border: 1px solid #f00;
    margin-left: 5px;
    cursor: pointer;
    pointer-events: auto;

    :hover {
        background-color: ${darken("#f00", 0.08)};
    }
`;

const Retry = styled("div")`
    font-size: 0.75rem;
    color: #f00;
    padding-top: 0.5em;
    align-self: flex-end;
    cursor: pointer;

    :hover {
        color: ${darken("#f00", 0.08)};
    }
`;

export const Failed = ({ message, retry }: Props) => {
    const { t } = useTranslation();

    return (
        <MessageWrapper user={null}>
            <ErrorWrapper>
                <MessageBubble user={null}>{message}</MessageBubble>
                <span onClick={retry}>
                    <RetryIcon />
                </span>
            </ErrorWrapper>
            <Retry onClick={retry}>{t("MessageCenter.Failed.NotDelivered")}</Retry>
        </MessageWrapper>
    );
};

export default Failed;
